import MyPicker from './picker.vue'

const Picker = {
  install: function (Vue) {
    Vue.component('MyPicker', MyPicker)
  }
}

export default Picker



// WEBPACK FOOTER //
// ./src/components/picker/index.js